import { Hero } from './styles'

const HeroComponent = () => <Hero />

export default HeroComponent
